import axios from "axios";
import store from "@/store/index.js"
import Swal from 'sweetalert2'

const swalBase = {
    background: '#fff',
    color: '#1e293b',
    customClass: {
        popup:         'swal-custom-popup',
        title:         'swal-custom-title',
        htmlContainer: 'swal-custom-text',
        confirmButton: 'swal-custom-btn',
        cancelButton:  'swal-custom-btn',
        actions:       'swal-custom-actions',
    },
    showClass: { popup: 'swal-show-animation' },
    hideClass: { popup: 'swal-hide-animation' },
}

axios.interceptors.request.use(config => {
    // config.baseURL = "http://127.0.0.1:8003/api",

    config.baseURL = "https://hilla-api.crc-almandelawi.com/api",
    config.method == "get" ? store.state.getLoader = true : store.state.postLoader = true
    config.headers = {
        'Access-Control-Allow-Origin':'*',
        'Authorization': `Bearer ${ localStorage.getItem('car_user_Info') !== null ? JSON.parse(localStorage.getItem('car_user_Info'))?.token : ''}`
    }
    return config;
})

axios.interceptors.response.use(response => {
    response.config.method == "get" ? store.state.getLoader = false : store.state.postLoader = false
    if(response.config.method !== 'get'){
        Swal.fire({
            ...swalBase,
            position: 'center',
            icon: 'success',
            iconColor: '#10b981',
            title: 'تمت العملية بنجاح',
            text: response.data.message,
            showConfirmButton: false,
            timer: 1800,
            timerProgressBar: true,
        })
    }
    return response
}, (error)=>{
    if(error.response.status == 401){
        localStorage.removeItem("car_user_Info");
        window.location.reload()
    }

    store.state.getLoader = false
    store.state.postLoader = false

    if(error.response.status == 400){
        var setError = "";
        for (var key in error.response.data) {
            setError += `${error.response.data[key][0]}\n`;
        }
        Swal.fire({
            ...swalBase,
            icon: 'error',
            iconColor: '#ef4444',
            title: 'خطأ في البيانات',
            text: setError,
            showConfirmButton: true,
            confirmButtonText: '<i class="fas fa-check ml-1"></i> حسناً',
            confirmButtonColor: '#10b981',
        })
    } else {
        Swal.fire({
            ...swalBase,
            icon: 'error',
            iconColor: '#ef4444',
            title: 'حدث خطأ',
            text: error.response.data.message,
            showConfirmButton: true,
            confirmButtonText: '<i class="fas fa-check ml-1"></i> حسناً',
            confirmButtonColor: '#10b981',
        })
    }

    return Promise.reject(error);
})

export default axios;
